import { devices } from "@app/config/devices";
import styled from "styled-components";

export const MaterialTableContainer = styled.div`
  && {
    margin-top: 1rem;
    margin-bottom: 2rem;
    
    .MuiPaper-root {
      box-shadow: none;
      background-color: transparent;
    }
    .MuiTableRow-root {
      height: 60px !important;
    }
    .MuiTableCell-root {
      background-color: transparent;
      white-space: nowrap !important;
      //height: 120px !important;
    }
    .MuiIconButton-colorInherit {
      padding: 7px;
    }
    .MuiIconButton-colorInherit {
      color: #0D47A1;
      font-size: 10px;
    }
    .css-17ijfcn-MuiTableRow-root {
      height: 60px !important;
    }
    .css-apqrd9-MuiTableBody-root {
      background-color: #F7FBFF;
    }
    @media (max-width: ${devices.xs}) {
      .css-1wbhww1-MuiTable-root {
        display: block;
      }

    }
  }
`;

export const StyledTitle = styled.div`
  h6 {
    padding-left: 25px;
  }
  h5 {
    // border-left: 3px solid ${({ theme }) => theme.primary.main};
    background-color: ${({ theme }) => theme.primary.navBarContent};
    color: ${({ theme }) => theme.primary.contrastText};
    padding: 10px;
    padding-left: 30px;
    width: 30rem;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-left: -6rem;
  }

  @media ${devices.xs} {
    h5 {
      width: 100%;
      margin-left: auto;
    }
  }
`;